import React, { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { spring } from "../../utils/motion";
interface AuthCardProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  top?: ReactNode;
}
export function AuthCard({
  title,
  description,
  children,
  footer,
  top
}: AuthCardProps) {
  const reduce = useReducedMotion() ?? false;
  return <motion.div initial={reduce ? false : {
    opacity: 0,
    y: 20,
    scale: 0.98
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={spring.heavy} data-id="element-87" data-mp="gwsb9uwaqkd0">
      <div className="rounded-panel border-3 border-line bg-surface p-6 shadow-brutal-lg sm:p-8" data-id="element-88" data-mp="7wde9y9yzgto">
        {top}
        <h1 className="text-[28px] font-bold leading-tight tracking-[-0.02em] text-ink" data-id="element-89" data-mp="bxp8yi7pas8q">{title}</h1>
        {description && <p className="mt-2 text-[15px] leading-relaxed text-ink-2" data-id="element-90" data-mp="22a4whm6d790q">{description}</p>}
        <div className="mt-6" data-id="element-91" data-mp="26chzw3xn2uuc">{children}</div>
      </div>
      {footer && <div className="mt-6 text-center text-[15px] text-ink-2" data-id="element-92" data-mp="269nfudijfc1g">{footer}</div>}
    </motion.div>;
}